module.exports = __webpack_public_path__ + "static/media/initial_empty.5bdd419f.svg";